export const PLAN_LIMITS = {
  // history: 応募者履歴・当選回数・自動最低設定などの閲覧可否
  basic: { maxEvents: 2,        maxStaff: 2,        bothSelect: true, history: false },
  pro:   { maxEvents: Infinity, maxStaff: Infinity, bothSelect: true, history: true  },
  // 体験版(Trial): 全機能アクセス可。ただしイベント1・スタッフ1まで
  trial: { maxEvents: 1,        maxStaff: 1,        bothSelect: true, history: true  },
};

/** プラン名からリミットオブジェクトを返す。不明なプランは basic 扱い */
export const getLimits = (plan) =>
  PLAN_LIMITS[plan?.toLowerCase()] ?? PLAN_LIMITS.basic;

/** そのプランが履歴機能を使えるか */
export const planHasHistory = (plan) => !!getLimits(plan).history;

/** 上限が無制限かどうか */
export const isUnlimited = (max) => max === Infinity;

/** 表示用の上限文字列 */
export const formatMax = (max) => (isUnlimited(max) ? '無制限' : String(max));

/**
 * ライセンスの expires_at が期限切れかどうか。
 * 当日（expires_at の日付当日）は有効とし、翌日0時以降を期限切れとする。
 */
export const isLicenseDateExpired = (expiresAt) => {
  const todayStart = new Date(); todayStart.setHours(0, 0, 0, 0);
  const expiryStart = new Date(expiresAt); expiryStart.setHours(0, 0, 0, 0);
  return todayStart > expiryStart;
};
